import debounce from './debounce';
import equalizeHeight from './equalizeHeight';
import equalizeHeightBreakpoints from './equalizeHeightBreakpoints';
import isBelowBreakpoint from './isBelowBreakpoint';

const equalizeHeightResized = (items, breakpoints = 1) => {
  const delay = 350;
  const debouncedEqualize = debounce(equalizeHeight, delay);

  const resetHeight = () => {
    items.forEach(item => {
      // eslint-disable-next-line no-param-reassign
      item.style.minHeight = 'auto';
    });
  };

  window.addEventListener('resize', () => {
    const { width, columns } = equalizeHeightBreakpoints(breakpoints);

    if (!isBelowBreakpoint(width)) {
      debouncedEqualize(items, columns);
    } else {
      resetHeight();

      setTimeout(() => {
        resetHeight();
      }, delay + 100);
    }
  });
};

export default equalizeHeightResized;
